module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "menucard",
    class: _vm.modificator,
    attrs: {
      "to": _vm.goToPath
    }
  }, [_c('div', {
    staticClass: "menucard__icon",
    class: ("menucard__icon_" + _vm.type)
  }), _c('div', {
    staticClass: "menucard__wrapper"
  }, [_c('h3', {
    staticClass: "menucard__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "menucard__more"
  }, [_vm._v("подробнее")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019b43c0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/remotemenu/components/menucard/MenuCard.vue
// module id = e5056c3d507a08b01124
// module chunks = 89